import FixaSSRIcon from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import CircleFilledIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/CircleFilledIconPath";
import { ComponentNotificationTitleSeriesEnd } from "../types/task-notification.types";
import styles from "../task-notification.module.css";
import { useTranslation } from "@coworker/locales";

interface TaskNotificationTitleCreatorSeriesEndProps extends ComponentNotificationTitleSeriesEnd {
  read: boolean;
}

const TaskNotificationTitleCreatorSeriesEnd = ({
  read,
}: TaskNotificationTitleCreatorSeriesEndProps) => {
  const { t } = useTranslation();
  return (
    <div className={styles["task-notification-item-title"] ?? ""}>
      {!read && <FixaSSRIcon paths={CircleFilledIconPath} />}
      {t("taskSeriesEndedString")}
    </div>
  );
};

export default TaskNotificationTitleCreatorSeriesEnd;
